import Vue from "vue";

const state = {
  user: {
    email: "",
    firstName: "",
    lastName: "",
    supplierId: "",
    surgeryId: "",
    userPositionId: "",
    gdcNumber: ""
  },
  userPositions: [],
  address: {
    label: "",
    address: "",
    apt_no: "",
    state: "",
    postcode: "",
    city: "",
    countryId: ""
  },
  addresses: [],
  userAddress: {
    phone: "",
    email: "",
    addressId: ""
  },
  active: ""
};

const getters = {};

const actions = {
  GET_USER: async function({ commit, rootState }) {
    if (rootState.auth.user) {
      await Vue.prototype.$axios
        .get("/users/" + rootState.auth.user.uid)
        .then(res => {
          commit("SET_USER", res.data.user);
        });
    }
  },
  GET_USER_POSITIONS: async function({ commit }) {
    await Vue.prototype.$axios.get("/user/positions").then(res => {
      commit("SET_USER_POSITIONS", res.data.userPositions);
    });
  },
  UPDATE_USER_ADDRESS: async function(context, payload) {
    await Vue.prototype.$axios.post("/users/" + payload.id, payload);
  },
  GET_USER_ADDRESSES: async function({ commit, rootState }) {
    if (rootState.auth.user) {
      await Vue.prototype.$axios
        .get("/users/" + rootState.auth.user.uid + "/addresses")
        .then(res => {
          commit("SET_USER_ADDRESS", res.data.userAddresses);
        });
    }
  },
  CREATE_ADDRESS: async function({ dispatch, commit, rootState }, payload) {
    let label = `${payload.aptNo} ${payload.address}, ${payload.city}, ${payload.postcode}`;
    label = label.length > 25 ? `${label.substring(0, 25)}...` : label;
    await Vue.prototype.$axios
      .post("/users/" + rootState.auth.user.uid + "/addresses", {
        ...payload,
        label: label
      })
      .then(() => {
        commit("SET_EMPTY_ADDRESS");
      });
    await dispatch("GET_USER_ADDRESSES");
  },
  UPDATE_ADDRESS: async function({ dispatch, commit, rootState }, payload) {
    await Vue.prototype.$axios
      .post(
        "/users/" + rootState.auth.user.uid + "/addresses/" + payload.id,
        payload
      )
      .then(() => {
        commit("SET_EMPTY_ADDRESS");
      });
    await dispatch("GET_USER_ADDRESSES");
  },
  DELETE_ADDRESS: async function({ dispatch, rootState }, payload) {
    await Vue.prototype.$axios.delete(
      "/users/" + rootState.auth.user.uid + "/addresses/" + payload.id
    );
    await dispatch("GET_USER_ADDRESSES");
  },
  SAVE_ADDRESS: async function({ dispatch, rootState }, payload) {
    if (rootState.auth.user) {
      if (payload.id !== null && payload.id !== undefined) {
        await Vue.prototype.$axios.post(
          "/users/" + rootState.auth.user.uid + "/addresses/" + payload.id,
          {
            ...payload,
            label: payload.address + payload.city
          }
        );
      } else {
        await Vue.prototype.$axios.post(
          "/users/" + rootState.auth.user.uid + "/addresses",
          {
            ...payload,
            label: payload.address + payload.city
          }
        );
        await dispatch("GET_USER_ADDRESSES");
      }
    }
  }
};

const mutations = {
  SET_USER(state, payload) {
    payload.phone = "";
    state.user = payload;
  },
  SET_USER_POSITIONS(state, payload) {
    state.userPositions = payload;
  },
  SET_EMPTY_ADDRESS(state) {
    state.address = {
      label: "",
      address: "",
      apt_no: "",
      state: "",
      postcode: "",
      city: "",
      countryId: ""
    };
  },
  SET_USER_ADDRESS(state, payload) {
    if (payload.length > 0) {
      state.addresses = payload;
      state.userAddress.addressId = payload[0].id;
    }
  },
  LOAD_ADDRESS(state, payload) {
    state.address = payload;
  },
  PUSH_ADDRESS(state) {
    state.addresses.map(address => (address.active = false));
    if (
      state.addresses.length < 1 ||
      (state.addresses[state.addresses.length - 1].id !== undefined &&
        state.addresses[state.addresses.length - 1].id !== null)
    ) {
      state.addresses.push({
        label: "",
        address: "",
        apt_no: "",
        state: "",
        postcode: "",
        city: "",
        countryId: "",
        active: true
      });
    } else {
      state.addresses[state.addresses.length - 1].active = true;
    }
  },
  CHANGE_ACTIVE(state, payload) {
    state.addresses.map(address => {
      address.active = payload == address.id ? true : false;
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
